import { Breakpoint, Typography } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { ImageProps } from 'app/components/image';
import { errorImageProps, infoImageProps } from 'app/resources/images';

import { AlertType } from './alert-type';
import { StyledAlert, StyledAlertProps, StyledIcon, StyledTitle, StyledWrapper } from './alert.styled';

interface OwnProps {
    title: string;
    text: React.ReactNode;
}

type Props = OwnProps & StyledAlertProps;

const ALERT_ICON: Record<AlertType, ImageProps> = {
    [AlertType.ERROR]: errorImageProps,
    [AlertType.INFO]: infoImageProps,
};

export const Alert: FunctionComponent<Props> = (props: Props) => {
    const { title, text, type, ...rest } = props;

    return (
        <StyledAlert type={type} {...rest}>
            <StyledWrapper>
                <StyledIcon {...ALERT_ICON[type]} />
                <StyledTitle variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                    {title}
                </StyledTitle>
            </StyledWrapper>
            <Typography variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
                {text}
            </Typography>
        </StyledAlert>
    );
};
